import { FileText, Download } from "lucide-react";
import { PageHero, Reveal, SectionHead, PlaceholderTag } from "../components/common";
import { DOCUMENT_SECTIONS, ORG } from "../data/site";

export default function Transparency() {
  return (
    <>
      <PageHero
        overline="Transparency & Accountability"
        title="Responsible Stewardship"
        copy={`${ORG.name} (Reg. No. ${ORG.registration}) believes in responsible stewardship of every resource entrusted to it. Statutory registrations, certificates, annual reports and audited statements will be published on this page as official documents are provided. Documents not yet supplied are marked as pending rather than implied.`}
      />
      <section className="pb-24 md:pb-32">
        <div className="max-w-[90rem] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {DOCUMENT_SECTIONS.map((doc, i) => (
              <Reveal key={doc.title} delay={i * 0.05} className="h-full">
                <div
                  data-testid={`document-card-${i}`}
                  className="bg-white border border-charcoal/5 rounded-2xl p-8 h-full flex flex-col gap-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                >
                  <FileText className="h-7 w-7 text-charcoal/30" strokeWidth={1.5} />
                  <h3 className="font-serif text-xl font-medium tracking-tight">{doc.title}</h3>
                  {doc.note && <p className="text-xs font-mono uppercase tracking-widest text-charcoal/50">{doc.note}</p>}
                  {doc.file ? (
                    <a
                      href={doc.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                      data-testid={`document-download-${i}`}
                      className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-terracotta hover:underline"
                    >
                      <Download className="h-4 w-4" /> Download PDF
                    </a>
                  ) : (
                    <div className="mt-auto flex items-center justify-between gap-3">
                      <PlaceholderTag text="Document to be added" />
                      <span className="inline-flex items-center gap-2 text-sm text-charcoal/30 cursor-not-allowed" aria-disabled="true">
                        <Download className="h-4 w-4" /> PDF
                      </span>
                    </div>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <div className="mt-16 bg-softgray rounded-2xl p-8 md:p-10">
              <SectionHead
                overline="A Note on Accuracy"
                title="Only verified information is published"
                copy="Registration numbers, certificates and financial documents appear on this website only when officially supplied by the Trust. If you require a specific document, please write to us through the Contact page."
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
